import { useEffect } from 'react';

interface UseMatchCloseCheckProps {
	openingTime: string | null | undefined;
	isMatchMakingInitiated: boolean;
	onMatchClose: () => void;
}

export const useMatchCloseCheck = ({
	openingTime,
	isMatchMakingInitiated,
	onMatchClose,
}: UseMatchCloseCheckProps) => {
	useEffect(() => {
		if (isMatchMakingInitiated || !openingTime) return;

		const checkTime = () => {
			const now = Date.now();
			const opening = new Date(openingTime).getTime();
			const fiveMinutesInMs = 5 * 60 * 1000;

			if (now >= opening - fiveMinutesInMs) {
				onMatchClose();
			}
		};

		checkTime();
		const interval = setInterval(checkTime, 10000); // Check every 10 seconds

		return () => clearInterval(interval);
	}, [isMatchMakingInitiated, openingTime, onMatchClose]);
};
